export enum EAppRoutes {
  Home = '/',
  Login = '/login',
  Logout = '/logout',
  Admin = '/admin',
  AdminUsersInvite = '/admin/users-invite',
  CampaignManagement = '/campaign-management',
  CreateCampaign = '/campaign-management/create/campaign',
  EditCampaign = '/campaign-management/edit/campaign/:objectId',
  BulkEditCampaign = '/campaign-management/bulk-edit/campaign',
  CreateStrategy = '/campaign-management/:objectId/create/strategy',
  EditStrategy = '/campaign-management/:objectId/edit/strategy/:strategyId',
  BulkEditStrategy = '/campaign-management/bulk-edit/strategies',
  BulkEditStrategyOptimization = '/campaign-management/bulk-edit/strategies/optimization/:tab',
  CreateStrategyOptimization = '/campaign-management/:objectId/create/strategy-optimization/:strategyId/:tab',
  EditStrategyOptimization = '/campaign-management/:objectId/edit/strategy-optimization/:strategyId/:tab',
  ViewCampaign = '/campaign-management/view/:objectId',
  /**
   * TARGETING ROUTES
   * TODO: refactor targeting to separate route groups
   */
  // targeting technologyProfile
  TargetingDeviceType = 'technologyProfile/deviceType',
  TargetingOs = 'technologyProfile/operatingSystem',
  TargetingInventoryBrowser = 'technologyProfile/browser',
  TargetingCarrier = 'technologyProfile/carrier',
  // targeting placement
  TargetingBannerPlacement = 'placement/bannerPlacement',
  TargetingVideoPlacement = 'placement/videoPlacement',
  // targeting creatives
  TargetingCreativeBanner = 'creatives/banner',
  TargetingCreativeNative = 'creatives/native',
  TargetingCreativeAudio = 'creatives/audio',
  TargetingCreativeVideo = 'creatives/video',
  TargetingIabFormats = 'creatives/iabFormats',
  TargetingFrequency = 'frequency/frequency',
  TargetingSupplySource = 'inventory/supplySource',
  TargetingVerifiedSource = 'inventory/verifiedSource',
  TargetingInventoryDeals = 'inventory/deals',
  TargetingSiteAndApp = 'inventory/appSiteList',
  TargetingIabCategory = 'inventory/iabCategory',
  TargetingAppCategory = 'inventory/appCategory',
  TargetingDayParting = 'dayParting/dayPartingPanel',
  // targeting location
  TargetingLocationPOI = 'location/pointOfInterest',
  TargetingGeo = 'location/geographical',
  TargetingLanguage = 'content/language',
  TargetingGenre = 'content/genre',
  TargetingRating = 'content/rating',
  TargetingLive = 'content/live',
  TargetingProduction = 'content/production',
  ViewabilityProduction = 'prebid/viewability',
  ViewabilityBssAbs = 'prebid/bss-abs',
  /**
   * CREATIVES
   */
  Creatives = '/creatives',
  BannerBuilder = '/creatives/create/banner',
  BannerPreview = '/creatives/preview/banner/:creativeId',
  BannerEdit = '/creatives/edit/banner/:creativeId',
  NativeBuilder = '/creatives/create/native',
  NativePreview = '/creatives/preview/:creativeId', // for backward compatibility
  NativeNewPreview = '/creatives/preview/native/:creativeId',
  NativeEdit = '/creatives/edit/native/:creativeId',
  NativeSlideshowBuilder = '/creatives/create/slideshow',
  NativeSlideshowEditBuilder = '/creatives/edit/slideshow/:creativeId',
  NativeVideoBuilder = '/creatives/creative/native-video',
  NativeVideoEditBuilder = '/creatives/edit/native-video/:creativeId',
  AudioBuilder = '/creatives/create/audio',
  AudioPreview = '/creatives/preview/audio/:creativeId',
  AudioEdit = '/creatives/edit/audio/:creativeId',
  VideoBuilder = '/creatives/create/video',
  VideoPreview = '/creatives/preview/video/:creativeId',
  VideoEdit = '/creatives/edit/video/:creativeId',
  // CTV
  CtvCreate = '/creatives/create/ctv',
  CtvBuilderStandard = '/creatives/create/ctv/standard',
  CtvBuilderBrandAmplify = '/creatives/create/ctv/brand-amplify',
  CtvCreativeEdit = '/creatives/edit/ctv/:creativeId',
  CtvVariantPreview = '/creatives/preview/ctv/:creativeId/:variantId?',
  // Pause Ad Lift
  PalCreate = '/creatives/create/pal',
  PalEdit = '/creatives/edit/pal/:creativeId',
  PalPreview = '/creatives/preview/pal/:creativeId',

  /**
   * OTHER ROUTES
   */
  Reporting = '/reporting',

  /**
   * PLANNING
   */
  Planning = '/planning',
  /**
   * ADAPT CTV TEMPLATES
   */
  AdaptCtvTemplates = '/adapt-ctv-templates',
  EditAdaptCtvTemplateById = '/adapt-ctv-templates/:id',
  CreateAdaptCtvTemplate = '/adapt-ctv-templates/create',
}

export enum MainMenuKeyType {
  Admin = 'admin',
  CampaignManagement = 'campaignManagement',
  Creatives = 'creatives',
  Reporting = 'reporting',
  AdaptCtvTemplates = 'adaptCtvTemplates',
}

export enum ReportType {
  Performance = 'performance',
  Builder = 'builder',
  Conversion = 'conversion',
  EditBuilder = 'editBuilder',
}

export enum CreativeType {
  Banner = 1,
  Audio = 2,
  Video = 3,
  Native = 4,
}

export enum Permission {
  CreateAccounts = 1,
  ManageAccount = 2,
  ViewAccount = 3,
  ManageAccountRoles = 4,
  ReadAccountRoles = 5,
  ManageAccountAgencies = 6,
  ReadAccountAgencies = 7,
  ManageAccountAdvertisers = 8,
  ReadAccountAdvertisers = 9,
  ManageAccountUsers = 10,
  ReadAccountUsers = 11,
  ManageAccountDeals = 12,
  ReadAccountDeals = 13,
  ManageDealAccountVisibilities = 14,
  ReadDealAccountVisibilities = 15,
  ManageAccountLineItems = 16,
  ReadAccountLineItems = 17,
  ManageAccountStrategies = 18,
  ReadAccountStrategies = 19,
  ReadPermissions = 20,
  ManagePermissions = 21,
  ReadAccountAudiences = 22,
  ManageAccountAudiences = 23,
  AccessAdminModule = 24,
  AccessCampaignModule = 25,
  AccessDealModule = 26,
  AccessCreativeModule = 27,
  AccessReportingModule = 28,
  AccessAudienceModule = 29,
  AccessPlanningModule = 30,
  AccessAllAccounts = 31,
  InternalUser = 34,
}

export enum UserIdentityProvider {
  Okta = 1,
  Auth0 = 2,
}
